import React from 'react';
import { Widget } from './index';
import TaskWidget from '../../components/shared-components/TaskWidget';

export class WidgetTask extends Widget {
  constructor(obj = {}) {
    super(obj);
    this.task = obj.task;
    this.onClick = obj.onClick;
    this.cancelTask = obj.cancelTask;
  }

  getComponent() {
    return () => (
      <TaskWidget
        title={this.title}
        task={this.task}
        onClick={this.onClick}
        cancelTask={this.cancelTask}
      />
    );
  }

  transformToWidget = (data) => {
    this.title = data.title;
    this.type = data.type;
    this.size = data.size;
    this.task = data.task;
    this.onClick = data.onClick;
    this.cancelTask = data.cancelTask;
    return this;
  }
}